'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

    _this.state = { isHovering: false };
    return _this;
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var color = this.state.isHovering && this.props.hoverColor ? this.props.hoverColor : this.props.color;
      return _react2.default.createElement(
        'span',
        { onMouseOut: this.onMouseOut.bind(this), onMouseOver: this.onMouseOver.bind(this) },
        _react2.default.createElement(
          'svg',
          { viewBox: '-1.5 -1 18 12', width: '100%', height: '100%' },
          _react2.default.createElement('path', { d: 'M3.179 10.288c-1.044 0-1.835-.44-2.372-1.323C.269 8.083 0 6.81 0 5.141 0 1.714 1.06 0 3.179 0c1.057 0 1.856.44 2.396 1.323.54.882.81 2.154.81 3.818 0 3.431-1.069 5.147-3.206 5.147zm0-1.06c.67 0 1.162-.32 1.476-.96.315-.64.472-1.683.472-3.127 0-1.436-.157-2.474-.472-3.114-.314-.64-.806-.96-1.476-.96-.661 0-1.145.317-1.453.953-.308.636-.461 1.676-.461 3.12 0 1.45.153 2.493.461 3.131.308.639.792.958 1.453.958zm8.401 1.06c-1.044 0-1.834-.44-2.372-1.323-.538-.882-.807-2.156-.807-3.824C8.401 1.714 9.461 0 11.581 0c1.056 0 1.855.44 2.395 1.323.54.882.81 2.154.81 3.818 0 3.431-1.069 5.147-3.206 5.147zm0-1.06c.67 0 1.162-.32 1.477-.96.314-.64.471-1.683.471-3.127 0-1.436-.157-2.474-.471-3.114-.315-.64-.807-.96-1.477-.96-.66 0-1.145.317-1.453.953-.307.636-.461 1.676-.461 3.12 0 1.45.154 2.493.461 3.131.308.639.792.958 1.453.958z', fill: color })
        )
      );
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut() {
      this.setState({ isHovering: false });
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      this.setState({ isHovering: true });
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  color: _react.PropTypes.string.isRequired,
  hoverColor: _react.PropTypes.string
};
_class.displayName = 'Number';
exports.default = _class;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@segment/icons/build/react/Number.js
// module id = 1082
// module chunks = 0